module.exports = __webpack_public_path__ + "img/MendeleevDimitri.e9ce5648.jpg";